var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuietBetween = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.875,
  d: "M23.549 26.863v-2.302a4.76 4.76 0 0 0-3.98-4.698l-3.187-.53v-9.2a2.393 2.393 0 1 0-4.788 0v12.75l-1.723-.865a2.675 2.675 0 0 0-3.187.541 2.605 2.605 0 0 0 .319 3.77l.666.531"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.875,
  d: "M11.667 9.55H3.625l3.958-3.363a6.025 6.025 0 0 1 6.667-.939 6.02 6.02 0 0 1 6.664.939l3.961 3.362h-8.564M19.525 12.914a38 38 0 0 0 5.35-3.36M3.625 9.55a38 38 0 0 0 5.264 3.294"
})));
export default SvgQuietBetween;